import { useMutation } from 'react-query';

import { useSnackbar } from '@goodfynd/context';

import OrderApi from '../services/api/order-api';

interface AddTipData {
  id: string;
  tip?: number;
}

interface FinalizeInvoiceData {
  id: string;
  tip: number;
}

const orderApiServer = new OrderApi();

export const useInvoicePayment = () => {
  const { openSnackbar } = useSnackbar();

  return {
    addTipMutation: useMutation(
      ({ id, tip = 0 }: AddTipData) =>
        orderApiServer.addInvoiceTip(id, tip || 0),
      {
        onError(error: any) {
          console.error(error);
          openSnackbar({
            message: error?.message || 'An unknown error has occured',
            type: 'warning',
          });
        },
      }
    ),
    finalizeMutation: useMutation(
      ({ id, tip }: FinalizeInvoiceData) =>
        orderApiServer.finalizeInvoice(id, tip),
      {
        onError(error: any) {
          console.error(error);
          openSnackbar({
            message: error?.message || 'An unknown error has occured',
            type: 'warning',
          });
        },
      }
    ),
  };
};
